import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "@tanstack/react-router";

const MESSAGES = [
  "Hỏi AI để được tư vấn điều luật nhanh nhé!",
  "Gõ câu hỏi pháp lý của bạn, AI sẽ giải thích rõ.",
  "Tra cứu văn bản, điều luật — hỏi AI cho tiện.",
  "Không rõ quy định? Nhắn AI để được gợi ý.",
];

export default function FloatingChatWidget() {
  const navigate = useNavigate();
  const [msgIndex, setMsgIndex] = useState(0);
  const [display, setDisplay] = useState("");
  const [typing, setTyping] = useState(true);
  const [visible, setVisible] = useState(true);
  const timerRef = useRef<number | null>(null);
  const timerRef2 = useRef<number | null>(null);

  const text = useMemo(() => MESSAGES[msgIndex % MESSAGES.length], [msgIndex]);

  useEffect(() => {
    if (!visible) return; // ẩn thì không chạy typewriter
    setTyping(true);
    setDisplay("");
    let i = 0;
    const step = () => {
      i = Math.min(i + 1, text.length);
      setDisplay(text.slice(0, i));
      if (i < text.length) {
        timerRef.current = window.setTimeout(step, 28);
      } else {
        setTyping(false);
        // Hiển thị 5s, sau đó ẩn 2s rồi hiển thị câu tiếp theo
        timerRef.current = window.setTimeout(() => {
          setVisible(false);
        }, 3000);
        timerRef2.current = window.setTimeout(() => {
          setMsgIndex((s) => s + 1);
          setVisible(true);
        }, 5000);
      }
    };
    step();
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      if (timerRef2.current) window.clearTimeout(timerRef2.current);
    };
  }, [text]);

  return (
    <div
      className="fixed z-50"
      style={{ right: "10px", bottom: "87px", cursor: "pointer" }}
    >
      <div className="relative" style={{ width: "56px", height: "56px" }}>
        <style>{`
          @keyframes glowPulse { 0% { transform: scale(1); opacity: .7; } 70% { transform: scale(1.9); opacity: 0; } 100% { transform: scale(1.9); opacity: 0; } }
          .glow-wave { position:absolute; inset:0; border-radius:9999px; pointer-events:none; z-index:0; 
            background: rgba(251,146,60,0.35); box-shadow: 0 0 28px 18px rgba(251,146,60,0.35), 0 0 60px 30px rgba(251,146,60,0.18);
            animation: glowPulse 2.4s ease-out infinite; }
          .glow-wave.delay-1 { animation-delay: .6s; }
          .glow-wave.delay-2 { animation-delay: 1.2s; }
        `}</style>
        <span className="glow-wave" />
        <span className="glow-wave delay-1" />
        <span className="glow-wave delay-2" />

        {/* Bubble message (top-left of widget) */}
        {visible && (
          <div
            className="absolute  w-[210px] bg-white rounded-2xl shadow-lg px-4 py-3 text-[13px] text-gray-800 select-none"
            style={{
              filter: "drop-shadow(0 8px 20px rgba(0,0,0,.08))",
              bottom: "67px",
              right: 9,
            }}
          >
            <div className="flex items-start gap-2">
              <span className="leading-5" aria-live="polite">
                {display}
                {typing && <span className="animate-pulse">|</span>}
              </span>
            </div>
            <div className="absolute -bottom-2 right-[14px] w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-white" />
          </div>
        )}

        <button
          onClick={() => navigate({ to: "/chat" })}
          aria-label="Mở chat AI"
          className="relative w-[56px] h-[56px] rounded-full bg-orange-50 shadow-xl flex items-center justify-center ring-1 ring-orange-200"
        >
          <img
            src="/images/bot_tab@3x.png"
            alt="AI"
            className="w-10 h-10 object-contain"
          />
        </button>
      </div>
    </div>
  );
}
